import Blazy from "blazy";

export default class LazyLoad {
  static instance: InstanceType<Blazy>;

  static invisible: InstanceType<Blazy>;

  static getInstance() {
    if (!LazyLoad.instance) {
      LazyLoad.instance = new Blazy({
        selector: ".lazyLoad, .invisibleLazyLoad",
        offset: 200,
        loadInvisible: true,
      });
    }

    return LazyLoad.instance;
  }

  static getInvisible() {
    if (!LazyLoad.invisible) {
      LazyLoad.invisible = new Blazy({
        selector: ".bLazyVisible",
        offset: 200,
        loadInvisible: false,
      });
    }

    return LazyLoad.invisible;
  }
}
